import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getSelectedReason, getUnvoluntaryReasons, ReasonGroup, VoluntaryReason, ReasonCategory } from '../model';

export const useReasonsGroup = () => {
	const { t } = useTranslation('Refund');

	const unvoluntaryReasons = useSelector(getUnvoluntaryReasons);
	const selectedReason = useSelector(getSelectedReason);

	return useMemo<ReasonGroup[]>(
		() =>
			[
				{
					category: ReasonCategory.Voluntary,
					title: t(ReasonCategory.Voluntary),
					reasons: [
						{
							title: t(VoluntaryReason.PlansChanged),
							checked: selectedReason?.reason === VoluntaryReason.PlansChanged,
							value: VoluntaryReason.PlansChanged,
							docs: []
						}
					]
				},
				unvoluntaryReasons?.length && {
					category: ReasonCategory.Involuntary,
					title: t(ReasonCategory.Involuntary),
					reasons: unvoluntaryReasons.map(reason => ({
						checked: selectedReason?.reason === reason.reason,
						value: reason.reason,
						title: t(reason.reason),
						docs: reason.docs
					}))
				}
			].filter(Boolean),
		[selectedReason, unvoluntaryReasons, t]
	);
};
